const routes = [
    {
        path: "/promotion/application/form",
        component: () => import("../pages/Index"),
        meta:{
            permission:'promotionalprocess_index'
        }
    },
];

export default routes;
